tenderView.controller('tenderViewBidsRequirementModalCtrl', function(
    $scope,
    $state,
    $timeout,
    $uibModalInstance,
    data,
    tenderBidService,
    ntFlash,
    $filter,
    DATETIME_FROMAT,
) {
    var tenderId = data.tenderId,
        awardId = data.awardId;
    $scope.procurementMethodType = data.procurementMethodType;

    $scope.disablePublishBtn = false;
    $scope.formData = {
        code: '24h',
        description: ''
    };
    $scope.dueDate = new Date()
    if($scope.procurementMethodType === 'requestForProposal'){
        const todayDate = new Date()
        todayDate.setDate(todayDate.getDate() + 1)
        $scope.dueDate = todayDate
        $scope.formData.dueDate = $filter('date')(todayDate.toISOString(), DATETIME_FROMAT);
    }


    $scope.publicRequirement = function() {
        $scope.disablePublishBtn = true;

        const data = {
            ...$scope.formData,
        }

        if($scope.formData.dueDate){
            data.dueDate = $filter('date')($scope.formData.dueDate, DATETIME_FROMAT)
        }

        tenderBidService.addMilestones(tenderId, awardId, data)
            .then(data => {
                ntFlash.success(gettext('Вимогу про усунення невідповідностей створено'));
                console.log('tenderBidService.addMilestones data', data);
                $uibModalInstance.close();
                $timeout(function() {
                    $state.reload();
                }, 1000);
            })
            .catch(error => {
                ntFlash.error(gettext('Сталася помилка', error));
                console.log('tenderBidService.addMilestones error', error);
            })
            .finally(() => {
                $scope.disablePublishBtn = false;
            });
        $uibModalInstance.close(data);
    };

    $scope.close = function() {
        $uibModalInstance.close();
    };
});
